import { clientInstance } from "../config/config";

export let startStudySessionAPI = async (flashcardId, review = false) => {
    return clientInstance.post(`/flashcard-progress/start/${flashcardId}${review ? '?review=true' : ''}`);
}

export let updateProgressAPI = async (progressId, cardId, masteryLevel) => {
    return clientInstance.put(`/flashcard-progress/card`, {
        progressId,
        cardId,
        masteryLevel
    });
}

export let getMyProgressAPI = async () => {
    return clientInstance.get(`/flashcard-progress/my`);
}

export let checkFlashcardProgressAPI = async (flashcardId) => {
    return clientInstance.get(`/flashcard-progress/flashcard/${flashcardId}/check`);
}

